import React from 'react';
import VersionClass from 'classes/VersionClass';

import PageComponent from './PageComponent';
import Layout from '../components/Layout';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UserActions from '../redux/UserActions';
import DownloadBtn from '../components/DownloadBtn';
import { withTranslation } from 'utils/with-i18next';
import Loading from '../components/Common/Loading';

import BASIC_CONSTANT from '../constants/basic.constants.js/basic.constants.js';
const section2Video = 'https://bgms-bucket.s3.ap-northeast-2.amazonaws.com/video/video.mp4';
import section1Img from '../assets/img/img1@2x.png';
import section3Img from '../assets/img/img2@2x.png';
import gtag from '../components/Analytics/gtag';
import Warning from '../assets/img/warning';
import NextHead from 'next/head';
import NotificationComponent from 'components/Notification/NotificationComponent';
class Download extends PageComponent {
  constructor() {
    super();
    this.state = {
      loading: true,
      version: null,
      os: 'Windows',
    };
    this.version = new VersionClass();
  }
  async componentDidMount() {
    super.componentDidMount();
    this.getOS();
    // this.getVersion();

    const versionInfo = await this.version.getVersion();

    this.setState({
      loading: false,
      version: versionInfo,
    });
  }

  getOS() {
    const platform = window.navigator.platform;
    const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
    const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
    let os = 'Windows';

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    }
    this.setState({ os });
  }

  // async getVersion() {
  //   let version = localStorage.getItem('version');
  //   if (version) {
  //     version = JSON.parse(version);
  //   }

  //   this.setState({ version });
  // }

  eventHandle(reverse) {
    const isServer = typeof window === 'undefined';
    let action;
    if (this.state.os === 'Mac') {
      action = 'mac_';
      if (reverse) action = 'win_';
    } else {
      action = 'win_';
      if (reverse) action = 'mac_';
    }

    if (!isServer) {
      gtag({
        action: `${action}download`,
        category: 'file_download',
        label: `${action}user`,
        value: 'user',
      });
    }
  }

  render() {
    const { t } = this.props;
    return (
      <Layout>
        <NextHead>
          <title>BGMs - 다운로드</title>
          <meta
            name="description"
            content="BGMs (브금쓰)는 Mac & Windows에서 무료로 사용할 수 있습니다. YouTube 플레이리스트를 공유하고, 공간에 음악을 채워보세요."
          />
          <meta property="og:title" content="BGMs - 다운로드" />
          <meta
            property="og:description"
            content="BGMs (브금쓰)는 Mac & Windows에서 무료로 사용할 수 있습니다. YouTube 플레이리스트를 공유하고, 공간에 음악을 채워보세요."
          />
          <meta property="og:url" content="https://bgms.live/download" />
          <meta
            name="subject"
            content="BGMs (브금쓰)는 Mac & Windows에서 무료로 사용할 수 있습니다. YouTube 플레이리스트를 공유하고, 공간에 음악을 채워보세요."
          />
          {/* <!-- twitter meta --> */}
          <meta name="twitter:domain" content="https://bgms.live/download" />

          <meta name="twitter:title" content="BGMs - 다운로드" />
          <meta
            name="twitter:description"
            content="BGMs (브금쓰)는 Mac & Windows에서 무료로 사용할 수 있습니다. YouTube 플레이리스트를 공유하고, 공간에 음악을 채워보세요."
          />
        </NextHead>
        {this.state.loading ? (
          <Loading />
        ) : (
          <div className="download">
            <section className="download-top">
              <div className="wrapB">
                {/* Downloads */}
                <h2 className="wow fadeInUp">{t('section-1.h2')}</h2>
                <p className="wow fadeInUp whiteSpace-pre" data-wow-delay=".3s">
                  {t('section-1.desc')}
                </p>
                <div className="btn_wrap wow fadeInUp" data-wow-delay=".5s" onClick={() => this.eventHandle()}>
                  {this.state.os === 'Windows' ? (
                    <DownloadBtn type="window" version={this.state.version} />
                  ) : (
                    <DownloadBtn type="mac" version={this.state.version} />
                  )}
                </div>
                <p className="down-info wow fadeInUp margin-top" data-wow-delay=".5s">
                  <a
                    className="down-info"
                    onClick={() => this.eventHandle('reverse')}
                    href={
                      this.state.os === 'Windows'
                        ? `${BASIC_CONSTANT.DOWNLOAD_URL}BGMs-${this.state.version}.dmg`
                        : `${BASIC_CONSTANT.DOWNLOAD_URL}BGMs-Setup-${this.state.version}.exe`
                    }>
                    <Warning />
                    혹시&nbsp; {this.state.os === 'Windows' ? 'Mac' : 'Windows'} 버전 이 필요하신가요?
                  </a>
                </p>
                {/* 경고 메시지 창이 뜨면서 리모컨 실행이 안되나요? */}
                <p className="down-info wow fadeInUp" data-wow-delay=".5s">
                  <a
                    className="down-info"
                    href="https://dodlab.notion.site/aebd5a56ed484c59b4dd776e563709bb"
                    target="_blank"
                    rel="noopener noreferrer">
                    <Warning />
                    보안 경고 메시지로 인해 설치가 어려우신가요?
                  </a>
                </p>
              </div>
            </section>

            <section className="bg-odd">
              <div className="bgmsIs wrapB">
                <div className="desc">
                  <span className="wow fadeInUp"> {t('bgmsIs')} </span>
                  <h2 className="wow fadeInUp whiteSpace-pre">{t('section.1.h2')}</h2>
                  <p className="wow fadeInUp whiteSpace-pre" data-wow-delay=".4s">
                    {t('section.1.p')}
                  </p>
                </div>
                <img className="with100 wow fadeInUp" data-wow-delay=".65s" src={section1Img} alt="" />
              </div>
            </section>
            <section>
              <div className="bgmsIs wrapB wow fadeInUp">
                <div className="desc">
                  <span className="wow fadeInUp"> {t('bgmsIs')} </span>
                  <h2 className="wow fadeInUp whiteSpace-pre">{t('section.2.h2')}</h2>
                  <p className="wow fadeInUp whiteSpace-pre" data-wow-delay=".4s">
                    {t('section.2.p')}
                  </p>
                </div>
                <video autoPlay loop muted playsInline className="with100 wow fadeInUp bg-video" data-wow-delay=".65s">
                  <source src={section2Video} type="video/mp4" />
                </video>
              </div>
            </section>
            <section className="bg-odd">
              <div className="bgmsIs wrapB">
                <div className="desc">
                  <span className="wow fadeInUp"> {t('bgmsIs')} </span>
                  <h2 className="wow fadeInUp whiteSpace-pre">{t('section.3.h2')}</h2>
                  <p className="wow fadeInUp whiteSpace-pre" data-wow-delay=".4s">
                    {t('section.3.p')}
                  </p>
                </div>
                <img className="with100 wow fadeInUp" data-wow-delay=".65s" src={section3Img} alt="" />
              </div>
            </section>

            {/* main page */}
            <section className="wrapB">
              <div className="bgmsIs-info">
                <div className="center">
                  {/*  이렇게 활용해 보세요 */}
                  <h3 className="wow fadeInUp">{t('section-2.h3')}</h3>
                  <p className="wow fadeInUp whiteSpace-pre" data-wow-delay=".3s">
                    {t('section-2.desc')}
                  </p>
                </div>
                <ul className="article-wrap">
                  <li className="article wow fadeInUp" data-wow-delay=".5s">
                    <span>01</span>
                    <h4>{t('article-1.h4')}</h4>
                    <p className="whiteSpace-pre">{t('article-1.p')}</p>
                  </li>
                  <li className="article wow fadeInUp" data-wow-delay=".7s">
                    <span>02</span>
                    <h4>{t('article-2.h4')}</h4>
                    <p className="whiteSpace-pre">{t('article-2.p')}</p>
                  </li>
                  <li className="article wow fadeInUp" data-wow-delay=".9s">
                    <span>03</span>
                    <h4>{t('article-3.h4')}</h4>
                    <p className="whiteSpace-pre">{t('article-3.p')}</p>
                  </li>
                </ul>
              </div>
            </section>
          </div>
        )}
      </Layout>
    );
  }
}

Download.propTypes = {
  UserRedux: PropTypes.object,
};

export default connect(
  state => state,
  (dispatch, ownProps) => {
    return { ...UserActions(dispatch, ownProps) };
  }
)(withTranslation('download')(Download));
